import { render, staticRenderFns } from "./modal-non-premium-integration-screen.vue?vue&type=template&id=3b341fef&scoped=true&"
import script from "./modal-non-premium-integration-screen.vue?vue&type=script&lang=js&"
export * from "./modal-non-premium-integration-screen.vue?vue&type=script&lang=js&"
import style0 from "./modal-non-premium-integration-screen.vue?vue&type=style&index=0&id=3b341fef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b341fef",
  null
  
)

export default component.exports